import React from 'react';
import { formatAssociatedOrderNumberForDisplay, formatOrderDateToLocalTime } from '../../../util';
import { Row, TableData } from 'components/common/tableElements';
import { STATUS_MAP } from 'constants/rbi';

const RbiSearchResult = ({ result, clickAction, even }) => (
  <Row onClick={() => clickAction(result)} hoverPointer={true} even={even}>
    <TableData className="order-number">{formatAssociatedOrderNumberForDisplay(result.rbiOrderId)}</TableData>
    <TableData>{formatOrderDateToLocalTime(result.createdAt, 'custom_rbi')}</TableData>
    <TableData>{result.customerName}</TableData>
    <TableData>{STATUS_MAP[result.status] || result.status}</TableData>
  </Row>
);

export default RbiSearchResult;
